import Taxonomies from "./taxonomies";

export default Taxonomies;


